import { takeEvery, call, put, fork } from 'redux-saga/effects';
import * as actions from '../ducks/instaFeed';
import * as api from '../services/api';
import toast from '../components/Toastify';

// createInstaFeedURL
function* createInstaFeedURL(data) {
  try {
    const res = yield call(api.GET, '/insta/createInstaFeedURL?wid=' + data.data.wid + '&id=' + data.data.id + '&cn=' + data.data.cn + '&wdtnm=' + data.data.wdtnm);
    if (res.status == 'success') {
      yield put(actions.createInstaFeedURLSuccess(res.data));
    }
    else {
      toast.error('Error in get user instagram URL');
    }
  } catch (error) {
    yield put(actions.createInstaFeedURLError(true));
  }
}

// getInstaFeedUser
function* getInstaFeedUser() {
  try {
    const res = yield call(api.GET, '/insta/getInstaFeedUser');
    if (res.status == 'success') {
      yield put(actions.getInstaFeedUserSuccess(res.data));
    }
    else {
      toast.error('Error in get user!');
    }
  } catch (error) {
    yield put(actions.getInstaFeedUserError(true));
  }
}

//instaFeedPaymant
function* instaFeedPaymant(data) {
  try {
    const res = yield call(api.GET, '/insta/instaFeedPaymant?wid=' + data.data.wid + '&id=' + data.data.id + '&cn=' + data.data.cn + '&wdtnm=' + data.data.wdtnm);
    if (res.status == 'success') {
      // console.log('res.data==keval=>', res.data);
      // window.location.href = res.data;
      window.parent.location.href = res.data;
    }
    else {
      toast.error('Error in get user!');
    }
  } catch (error) {
    yield put(actions.instaFeedPaymantError(true));
  }
}

export function* watch() {
  yield takeEvery(actions.GET_INSTAFEED_URL, createInstaFeedURL);
  yield takeEvery(actions.GET_INSTAFEED_USER, getInstaFeedUser);
  yield takeEvery(actions.INSTAFEED_PAYMANT, instaFeedPaymant);
}

export default function* rootSaga() {
  yield [
    fork(watch)
  ];
}


// WEBPACK FOOTER //
// ./src/sagas/instaFeed.js